import { useEffect } from 'react'

export default function SEO({
  title,
  description,
  canonical,
  ogImage = 'https://assets.auxodev.dk/assets/f44d6781-9183-40b0-88fc-e2c1542ad3e6/6a6f183f-a8d2-4ab1-ba69-46555a150cfd.jpg',
  ogType = 'website',
  schema = null,
  noindex = false,
}) {
  useEffect(() => {
    // Title
    if (title) {
      document.title = title
    }

    const setMeta = (attr, key, val) => {
      if (val === undefined || val === null) return
      let el = document.querySelector(`meta[${attr}="${key}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, key)
        document.head.appendChild(el)
      }
      el.setAttribute('content', val)
    }

    // Robots meta tag
    if (noindex) {
      setMeta('name', 'robots', 'noindex, nofollow')
    } else {
      setMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1')
    }

    // Description
    if (description) {
      setMeta('name', 'description', description)
      setMeta('property', 'og:description', description)
      setMeta('name', 'twitter:description', description)
    }

    // Open Graph / Twitter Titles
    if (title) {
      setMeta('property', 'og:title', title)
      setMeta('name', 'twitter:title', title)
    }

    // Canonical & URL - using https://www.djron9.dk with consistent trailing slashes
    let canonicalUrl = ''
    if (canonical) {
      if (canonical.startsWith('http')) {
        canonicalUrl = canonical
      } else {
        const cleanPath = canonical.startsWith('/') ? canonical : '/' + canonical
        const withSlash = cleanPath === '/' ? '/' : (cleanPath.endsWith('/') ? cleanPath : cleanPath + '/')
        canonicalUrl = `https://www.djron9.dk${withSlash}`
      }
    } else {
      const pathname = window.location.pathname
      const withSlash = pathname === '/' ? '/' : (pathname.endsWith('/') ? pathname : pathname + '/')
      canonicalUrl = `https://www.djron9.dk${withSlash}`
    }

    let canonicalLink = document.querySelector('link[rel="canonical"]')
    if (!canonicalLink) {
      canonicalLink = document.createElement('link')
      canonicalLink.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalLink)
    }
    canonicalLink.setAttribute('href', canonicalUrl)
    setMeta('property', 'og:url', canonicalUrl)
    setMeta('name', 'twitter:url', canonicalUrl)

    // Type, Site Name & Image
    setMeta('property', 'og:type', ogType)
    setMeta('property', 'og:site_name', 'DJ Ron9')
    setMeta('property', 'og:locale', 'da_DK')
    setMeta('name', 'twitter:card', 'summary_large_image')

    if (ogImage) {
      setMeta('property', 'og:image', ogImage)
      setMeta('name', 'twitter:image', ogImage)
    }

    // Schema JSON-LD
    let scriptEl = document.getElementById('page-schema-jsonld')
    if (schema) {
      if (!scriptEl) {
        scriptEl = document.createElement('script')
        scriptEl.id = 'page-schema-jsonld'
        scriptEl.type = 'application/ld+json'
        document.head.appendChild(scriptEl)
      }
      scriptEl.textContent = JSON.stringify(schema)
    } else if (scriptEl) {
      scriptEl.remove()
    }

    return () => {
      const el = document.getElementById('page-schema-jsonld')
      if (el) el.remove()
    }
  }, [title, description, canonical, ogImage, ogType, schema, noindex])

  return null
}
